import { type MCPServerInfo } from '../../types';

const PubchemServer: MCPServerInfo = {
  serverId: 'PUBCHEM',
  name: 'PubChem',
  slug: 'pubchem',
  description:
    "A comprehensive Model Context Protocol (MCP) server providing advanced access to the PubChem chemical database. This server offers 30 specialized tools enabling AI assistants and MCP clients to access over 110 million chemical compounds with extensive molecular properties, bioassay data, and chemical informatics tools through PubChem's REST API.",
  source: {
    sourceType: 'REPOSITORY',
    type: 'COMMUNITY',
    repositoryUrl: 'https://github.com/Augmented-Nature/PubChem-MCP-Server.git',
    commitSha: 'main',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'NONE',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  deprecated: true
};

export default PubchemServer;
